<template>
  <div class="submit-alert"
       v-show="visible">
    <!--<div class="bg-content"></div>-->
    <div class="main-content">
      <div class="main-header"><i class="ui-icon icon-jinggao"></i>提示</div>
      <div class="main-body">
          <span v-if="unAnswerCount > 0">
            <template v-if="isZhExam">
              <!--综合提示-->
              当前未完成试题题号：<strong class="text-warning">{{ unAnswerCount }}。</strong><br>
            </template>
            <template v-else>
              还有<strong class="text-warning">{{ unAnswerCount }}</strong>道题<strong class="text-warning">未完成</strong>,
            </template>
          </span>
        <span v-if="firstStatus">是否确认结束考试？</span>
        <span v-else>确认结束考试？</span>
        <p class="my-affirm ui-icon" v-if="!firstStatus" :class="{'onChecked':myIsChecked}"
           @click="myIsChecked = !myIsChecked">
          我确认，结束考试，结束后不可再次作答。</p>
      </div>
      <div class="main-footer">
        <button @click="firstStatus=false"
                v-if="firstStatus">确认
        </button>
        <button :disabled="!myIsChecked" :class="{'myIsCheckedButton':!myIsChecked}" @click="this.confirmFn"
                v-else>确认
        </button>
        <button class="btn-cancel"
                @click="closeDialog">取消
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {isCompositeCourse} from "@/utils"

export default {
  name: 'submitAlert',
  props: {
    visible: {type: Boolean, default: false},
    unAnswerCount: {type: Number},
  },
  data() {
    return {
      firstStatus: true, //  是否处于第一步状态
      // unAnswerCount: 0,  //  未答题数量
      isZhExam: false,
      myIsChecked: false
    }
  },
  computed: {
    ...mapGetters([
      'questions',
      'currentQuestion',
      'currentQuestionType',
      'currentQuestionIndex',
    ]),
  },
  /*watch: {
    visible(newVal) {
      if(newVal) {
        let allCount = 0
        let unAnswerCount = 0
        for(let item of this.questions) {
          item.list.forEach((ques) => {
            allCount++
            !ques.isAnswer && unAnswerCount++
          })
        }
        this.isAnswered = (allCount !== unAnswerCount)
        this.unAnswerCount = unAnswerCount
      }
    }
  },*/
  async mounted() {
    const {
      siteCourseID,
      courseID,
    } = this.$route.query
    if (isCompositeCourse(siteCourseID, courseID)) {
      this.isZhExam = true
    } else {
      this.isZhExam = false
    }
  },
  methods: {
    closeDialog() {
      this.hide()
    },
    hide() {
      this.$emit('update:visible', false)
      this.$emit('update:multiStatus', false)
      this.firstStatus = true
    },
    confirmFn() {
      this.hide()
      this.$emit('submit')
    },
  },
}
</script>

<style lang="scss" scoped>
.submit-alert {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, .4);
  z-index: 999;
  //.bg-content {
  //  position: fixed;
  //  left: 0;
  //  top: 0;
  //  width: 100%;
  //  height: 100%;
  //  overflow: auto;
  //  background-color: rgba(0, 0, 0, 0.4);
  //  z-index: 999;
  //}

  .main-content {
    width: 550px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #666;
    background-color: #fefefe;
    margin: auto;
    padding: 0 0 40px;
    min-height: 260px;
    border: 1px solid #888;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    -webkit-animation-name: animateTop;
    -webkit-animation-duration: .4s;
    -webkit-animation-name: animatetop;
    animation-name: animatetop;
    animation-duration: .4s;

    .main-header {
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 18px;
      color: #333;
      border-bottom: 1px solid #dcdcdc;
      padding: 0 15px;

      .ui-icon {
        vertical-align: middle;
        margin: -3px 5px 0 0;
        font-size: 22px;
        color: #ff9c3e;
        display: inline-block;
      }
    }

    .main-body {
      text-align: center;
      font-size: 17px;
      color: #666;
      padding: 16px 20px 20px;
      line-height: 26px;

      .text-warning {
        color: #ff9c3e;
      }

      .my-affirm {
        font-size: 15px;
        margin-top: 20px;
        cursor: pointer;

        &:before {
          width: 16px;
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          border: 1px solid #999;
          display: inline-block;
          content: '';
          vertical-align: middle;
          margin: -3px 6px 0 0;
          overflow: hidden;
        }
      }

      .onChecked {
        &:before {
          border-color: #447dff;
          background: #447dff;
          content: "\e600";
          color: #fff;
        }
      }
    }

    .main-footer {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;

      button {
        min-width: 100px;
        border-radius: 4px;
        background: #447dff;
        color: #fff;
        border: 1px solid #447dff;
        padding: 5px;

        &.btn-cancel {
          background: none;
          color: #999;
          border: 1px solid #999;
          margin-left: 24px;
        }

        &:hover {
          opacity: .9
        }
      }

      .myIsCheckedButton {
        background: #8c93ac;
        border-color: #8c93ac;

        &:hover {
          opacity: 1
        }
      }
    }
  }
}
</style>

